import { ReactNode } from "react";

import { PublicScreenWrapperWithEnvironmentBanner } from "components/PublicScreenWrapper/PublicScreenWrapper";
import { useTranslation } from "i18n";
import { Translation } from "i18n/Translation";

export const CoreApiSignup = () => {
  const t = useTranslation();

  return (
    <PublicScreenWrapperWithEnvironmentBanner image="COPILOT">
      <div className="w-full max-w-[450px] flex-col">
        <div className="title mb-24 leading-tight">
          {t("signup.disabled.title")}
        </div>
        <div className="text-body text-16">
          <Translation
            k="signup.disabled.message"
            components={{ contactLink: ContactLink }}
          />
        </div>
      </div>
    </PublicScreenWrapperWithEnvironmentBanner>
  );
};

const ContactLink = ({ children }: { children: ReactNode }) => (
  <a className="link" href="mailto:api@nabla.com">
    {children}
  </a>
);
